import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import Router from 'vue-router'
import learnItemIndex from '@/assets/learn/index'
Vue.use(Router)

const SITE_TITLE = process.env.VUE_APP_SITE_TITLE
const SITE_URL = process.env.VUE_APP_SITE_URL
const NOT_FOUND_PATH = '/404'

const previewProps = function (route) {
  return {
    preview: true,
    formatId: route.params.formatId,
    cardId: route.params.cardId,
    planId: route.params.planId
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      component: () =>
        import('@/views/Home.vue'),
      name: 'home',
      meta: {
        title: SITE_TITLE
      }
    },
    {
      path: '/learn',
      component: () =>
        import('@/views/learn/LearnList.vue'),
      name: 'learnList',
      meta: {
        title: '事業計画書の基礎知識 - ' + SITE_TITLE,
        description: '事業計画書を書くときに知っておきたい基礎知識です。資金調達や融資の際に必要な項目や書き方のポイント、トラブルを避けるための対処方法などを起業の専門家がわかりやすく解説します。'
      }
    },
    {
      path: '/learn/:learnId',
      component: () =>
        import('@/views/learn/LearnDetail.vue'),
      name: 'learnDetail',
      meta: {},
      props: true
    },
    {
      path: '/simulate',
      component: () =>
        import('@/views/simulate/Simulate.vue'),
      name: 'simulate',
      meta: {
        title: '事業資金シミュレーター - ' + SITE_TITLE,
        description: SITE_TITLE + 'の事業資金シミュレーターページです。事業資金を借り入れした場合の金利・返済額をシミュレーションします。実際の融資は金融機関によって種類や計算が異なりますので、おおよその返済額のシミュレーションとしてお使いください。'
      }
    },
    {
      path: '/plan',
      component: () =>
        import('@/views/plan/PlanList.vue'),
      name: 'planList',
      meta: {
        requiresAuth: true,
        title: '事業計画書一覧 - ' + SITE_TITLE
      }
    },
    {
      path: '/plan/:planId',
      component: () =>
        import('@/views/plan/PlanDetail.vue'),
      name: 'planDetail',
      props: true,
      meta: {
        requiresAuth: true,
        title: '事業計画書の編集 - ' + SITE_TITLE
      }
    },
    {
      path: '/plan/:planId/edit',
      component: () =>
        import('@/views/plan/BasicPlan.vue'),
      name: 'editBasicPlan',
      props: true,
      meta: {
        requiresAuth: true,
        title: '基本計画の編集 - ' + SITE_TITLE
      }
    },
    {
      path: '/plan/:planId/preview',
      component: () =>
        import('@/views/plan/BasicPlan.vue'),
      name: 'previewBasicPlan',
      props: previewProps,
      meta: {
        requiresAuth: true,
        title: '基本計画のプレビュー - ' + SITE_TITLE
      }
    },
    {
      path: '/login',
      component: () =>
        import('@/views/account/SigninAndLogin.vue'),
      name: 'login',
      props: { loginOrSignin: 'login' },
      meta: {
        title: 'ログイン - ' + SITE_TITLE
      }
    },
    {
      path: '/signin',
      component: () =>
        import('@/views/account/SigninAndLogin.vue'),
      name: 'signin',
      props: { loginOrSignin: 'signin' },
      meta: {
        title: 'サインイン - ' + SITE_TITLE
      }
    },
    {
      //依頼入力ページ
      path: '/consultation',
      component: () =>
        import('@/views/consultation/RequestConsultation.vue'),
      name: 'requestConsultation',
      meta: {
        requiresAuth: true,
        title: '相談依頼の入力 - ' + SITE_TITLE
      }
    },
    {
      //ユーザー側履歴一覧
      path: '/consultation/history',
      component: () =>
        import('@/views/consultation/ConsultationHistoryList.vue'),
      name: 'consultationHistoryList',
      meta: {
        requiresAuth: true,
        title: '相談依頼の一覧 - ' + SITE_TITLE
      }
    },
    {
      //ユーザー側履歴詳細
      path: '/consultation/history/:consultationId',
      component: () =>
        import('@/views/consultation/ConsultationHistoryDetail.vue'),
      name: 'consultationHistoryDetail',
      props: true,
      meta: {
        requiresAuth: true,
        title: '相談依頼の詳細 - ' + SITE_TITLE
      }
    },
    {
      //ユーザー側添削コメント確認
      path: '/correction/result/:consultationId',
      component: () =>
        import('@/views/consultation/CorrectionResult.vue'),
      name: 'correctionResult',
      props: true,
      meta: {
        requiresAuth: true,
        title: '相談コメントの確認 - ' + SITE_TITLE
      }
    },
    {
      //専門家側依頼一覧
      path: '/expert/consultation/case',
      component: () =>
        import('@/views/expert/ConsultationCaseList.vue'),
      name: 'consultationCaseList',
      meta: {
        requiresAuth: true,
        title: '相談案件の一覧 - ' + SITE_TITLE
      }
    },
    {
      //専門家側依頼詳細
      path: '/expert/consultation/case/:consultationId',
      component: () =>
        import('@/views/expert/ConsultationCaseDetail.vue'),
      name: 'consultationCaseDetail',
      props: true,
      meta: {
        requiresAuth: true,
        title: '相談案件の詳細 - ' + SITE_TITLE
      }
    },
    {
      //専門家コメント入力
      path: '/expert/tocorrect/:consultationId',
      component: () =>
        import('@/views/expert/ToCorrectConsultation.vue'),
      name: 'toCorrectConsultation',
      props: true,
      meta: {
        requiresAuth: true,
        title: '相談コメント編集 - ' + SITE_TITLE
      }
    },
    {
      path: '/help',
      name: 'helpPage',
      component: () =>
        import('@/views/pages/Help'),
      meta: {
        title: 'ヘルプ - ' + SITE_TITLE,
        description: SITE_TITLE + 'のヘルプページです'
      }
    },
    {
      path: '/notice',
      name: 'noticePage',
      component: () =>
        import('@/views/pages/Notice'),
      meta: {
        title: 'お知らせ - ' + SITE_TITLE,
        description: SITE_TITLE + 'のお知らせページです'
      }
    },
    {
      path: '/terms',
      component: () =>
        import('@/views/pages/Terms'),
      name: 'termsPage',
      meta: {
        title: '利用規約 - ' + SITE_TITLE,
        description: SITE_TITLE + 'の利用規約ページです'
      }
    },
    {
      path: '/howto',
      component: () =>
        import('@/views/pages/Howto'),
      name: 'howtoPage',
      meta: {
        title: '使い方ガイド - ' + SITE_TITLE,
        description: SITE_TITLE + 'の使い方ガイドページです'
      }
    },
    {
      path: '/supervisor',
      component: () =>
        import('@/views/pages/Supervisor'),
      name: 'supervisorPage',
      meta: {
        title: '監修者紹介 - ' + SITE_TITLE,
        description: SITE_TITLE + 'の監修者紹介ページです'
      }
    },
    {
      path: '/interview-supervisor',
      component: () =>
        import('@/views/pages/InterviewUeno'),
      name: 'interviewUenoPage',
      meta: {
        title: '監修者インタビュー - ' + SITE_TITLE,
        description: '創業融資で求められる「事業計画書」を書くことは、多くの人にとって人生初の経験です。日本政策金融公庫で融資課長を26年務めた起業支援コンサルタント・上野光夫氏に、事業計画書を書く際のまとめ方やチェックポイントを教えていただきました。',
        ogImage: SITE_URL + '/interview/images/ogp.png'
      }
    },
    {
      path: NOT_FOUND_PATH,
      component: () =>
        import('@/views/NotFound'),
      alias: ['/404.html'],
      name: 'notFound',
      meta: {
        title: 'ページが見つかりません - ' + SITE_TITLE
      }
    },
    {
      path: '*',
      redirect: { name: 'notFound' }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

if (process.env.VUE_APP_MODE === 'development') {
  const devRoutes = [
    {
      path: '/interview-supervisor',
      component: () =>
        import('@/views/pages/InterviewUeno'),
      name: 'interviewUenoPage',
      meta: {
        title: '監修者インタビュー - ' + SITE_TITLE,
        description: '創業融資で求められる「事業計画書」を書くことは、多くの人にとって人生初の経験です。日本政策金融公庫で融資課長を26年務めた起業支援コンサルタント・上野光夫氏に、事業計画書を書く際のまとめ方やチェックポイントを教えていただきました。',
        ogImage: SITE_URL + '/interview/images/ogp.png'
      }
    }
  ]
  router.addRoutes(devRoutes)
}
// https://firebase.google.com/docs/reference/js/firebase.auth.Auth#onAuthStateChanged
let onAuthStateChangedUnsubscribe
router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    next()
  } else {
    if (firebase.auth().currentUser !== null) {
      next()
      return
    } else {
      if (typeof onAuthStateChangedUnsubscribe === 'function') {
        onAuthStateChangedUnsubscribe()
      }
      onAuthStateChangedUnsubscribe = firebase.auth().onAuthStateChanged(function (currentUser) {
        if (currentUser) {
          next()
        } else {
          next({
            name: 'login'
          })
        }
      })
    }
  }
})

function setMetaToDocument(to, metaData) {
  const ogUrlElement = document.getElementById('head-og-url')
  ogUrlElement.content = SITE_URL + to.fullPath
  if (metaData.title) {
    document.title = metaData.title
    const ogTitleElement = document.getElementById('head-og-title')
    ogTitleElement.content = metaData.title
  }
  if (metaData.description) {
    const metaDescriptionElement = document.getElementById('head-meta-description')
    const metaOgDescriptionElement = document.getElementById('head-meta-og-description')
    metaDescriptionElement.content = metaData.description
    metaOgDescriptionElement.content = metaData.description
  }
  if (metaData.ogImage) {
    const metaOgImageElement = document.getElementById('head-meta-og-image')
    metaOgImageElement.content = metaData.ogImage
  }
}

router.afterEach((to, from) => {
  let metaData = {}
  if (to.params.learnId) {
    const learnItem = learnItemIndex.find(function (elem) {
      if (elem['id'] === to.params.learnId) {
        return elem
      }
    })
    metaData = {
      title: learnItem.title + ' - ' + SITE_TITLE,
      description: learnItem.description,
      ogImage: SITE_URL + learnItem.thumbnail
    }
  } else {
    metaData = to.meta
  }
  setMetaToDocument(to, metaData)
})

export default router
